import { PERFIL, CONFIGURACION } from '../actions/types';

const initialState = {
    perfil: null,
    metodos: {
        listado: [],
        detalles: null
    },
    productos: {
        listado: [],
        detalles: null
    }
};

export default function configuracionReducer(state = initialState, action) {
    switch (action.type) {

        case PERFIL.EDITAR:
            return { ...state, perfil: action.payload };

        /* Métodos */
        case CONFIGURACION.METODOS.BUSCAR:
            return { ...state, metodos: { ...state.metodos, listado: action.payload } };

        case CONFIGURACION.METODOS.AGREGAR:
            return { ...state, metodos: { ...state.metodos, listado: [action.payload, ...state.metodos.listado] } };

        case CONFIGURACION.METODOS.EDITAR:
            return {
                ...state,
                metodos: {
                    ...state.metodos,
                    listado: state.metodos.listado.map(metodo =>
                        metodo._id === action.payload._id ? action.payload : metodo
                    )
                }
            };

        case CONFIGURACION.METODOS.ELIMINAR:
            return {
                ...state,
                metodos: {
                    ...state.metodos,
                    listado: state.metodos.listado.filter(metodo => metodo._id !== action.payload)
                }
            };

        case CONFIGURACION.METODOS.DETALLES:
            return { ...state, metodos: { ...state.metodos, detalles: action.payload } };

        case CONFIGURACION.METODOS.LIMPIAR:
            return { ...state, metodos: { ...state.metodos, detalles: null } };

        /* Productos */
        case CONFIGURACION.PRODUCTOS.BUSCAR:
            return { ...state, productos: { ...state.productos, listado: action.payload } };

        case CONFIGURACION.PRODUCTOS.AGREGAR:
            return { ...state, productos: { ...state.productos, listado: [action.payload, ...state.productos.listado] } };

        case CONFIGURACION.PRODUCTOS.EDITAR:
            return {
                ...state,
                productos: {
                    ...state.productos,
                    listado: state.productos.listado.map(producto =>
                        producto._id === action.payload._id ? action.payload : producto
                    )
                }
            };

        case CONFIGURACION.PRODUCTOS.ELIMINAR:
            return {
                ...state,
                productos: {
                    ...state.productos,
                    listado: state.productos.listado.filter(producto => producto._id !== action.payload)
                }
            };

        case CONFIGURACION.PRODUCTOS.DETALLES:
            return { ...state, productos: { ...state.productos, detalles: action.payload } };

        case CONFIGURACION.PRODUCTOS.LIMPIAR:
            return { ...state, productos: { ...state.productos, detalles: null } };

        default:
            return state;
    }
}
